import PropTypes from 'prop-types';
import React, { useRef, useContext, useEffect, useState } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

// material-ui
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, Dialog, IconButton, Slide, TextField } from '@mui/material';

import { LangContext } from '../../utils/contaxt';
import components from '../../components';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuDialogContent-root': {
    padding: theme.spacing(2),
    
  },
  '& .MuDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: "white"
        }}
      >
        {/* <CloseIcon /> */}
      </IconButton>
    ) : null}
  </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} timeout={1000} />);
export default function Edit_Admin_profile({firstName, lastName, imgurl, email, UpdateCount, setUpdateCount}) {
  const {lang, first_Name, Last_Name, setlang, setfirst_Name, setLast_Name} = useContext(LangContext);
  const [open, setOpen] = React.useState(false);
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
  const [image, setImage] = useState(null);
  const cropperRef = useRef(null);

  const deleteimage = async () => {
    try {
      const uploadConfig = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      let upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image?isdeleted=true`, {}, uploadConfig);
      setImage(null);
      setlang(upLoadImage?.data?.imageUrl || '');
      localStorage.setItem("image", upLoadImage?.data?.imageUrl || '');
      toast.success(upLoadImage.data.message || "Image deleted successfully");
      if (setUpdateCount) {
        setUpdateCount(UpdateCount + 1);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      toast.error("Failed to delete image");
    }
  };

  const onSubmit = async () => {
    try {
      let imageUrl = null;
      
      // First, handle image upload if there's a new image
      if (image && cropperRef?.current) {
        const imageElement = cropperRef.current;
        const cropper = imageElement.cropper;
        
        if (typeof cropper.getCroppedCanvas() !== 'undefined') {
          // Convert the canvas to a Blob and upload
          const blob = await new Promise((resolve) => {
            cropper.getCroppedCanvas().toBlob((blob) => {
              resolve(blob);
            }, 'image/jpeg');
          });

          var formdata = new FormData();
          formdata.append("image", blob);

          const uploadConfig = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };

          const upLoadImage = await ApiCall.SECURE_API.post(`/file/upload-image`, formdata, uploadConfig);
          imageUrl = upLoadImage.data.imageUrl || upLoadImage.data.url || upLoadImage.data.image;
          
          if (imageUrl) {
            setlang(imageUrl);
            localStorage.setItem("image", imageUrl);
          }
        }
      }
      
      // Update the profile with basic data
      const UpdateProfile = await ApiCall.SECURE_API.put(`/admin/editprofile`, {
        "firstName": FirstName,
        "lastName": LastName
      });
      
      // Update context with the response data
      if (UpdateProfile.data.data.lastName) {
        setLast_Name(UpdateProfile.data.data.lastName);
      }
      if (UpdateProfile.data.data.firstName) {
        setfirst_Name(UpdateProfile.data.data.firstName);
      }
      
      toast.success("Profile updated successfully");
      
      // Refresh parent component
      if (setUpdateCount) {
        setUpdateCount(UpdateCount + 1);
      }
      
      handleClose();
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message || "Failed to update profile");
      }
      console.error("Error submitting data:", error);
      // Still refresh on error to show current state
      if (setUpdateCount) {
        setUpdateCount(UpdateCount + 1);
      }
    }
  };
  
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
    // Reset form fields to original values when closing
    setFirstName(firstName || '');
    setLastName(lastName || '');
    setImage(imgurl || null);
  };


  useEffect(() => {
    setImage(imgurl || null);
    setFirstName(firstName || '');
    setLastName(lastName || '');
  }, [lastName, firstName, imgurl]);




  return (
    <div>
      <Button style={{ }} variant="outlined" onClick={handleClickOpen}>
        Edit
      </Button>
      <BootstrapDialog
        fullWidth="sx"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}      >
          <BootstrapDialogTitle
          sx={{ position: 'relative', color: 'black',fontSize:20 }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Edit Profile
        </BootstrapDialogTitle>
        <DialogContent dividers>
        <div style={{}}>
           
               
            <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>First Name</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField 
                          value={FirstName} 
                          onChange={(e) => setFirstName(e.target.value)} 
                          style={{width:"100%"}} 
                          id="outlined-basic"  
                          variant="outlined" 
                        />
                        </div>
                 </div>
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Last Name</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <TextField 
                          value={LastName} 
                          onChange={(e) => setLastName(e.target.value)} 
                          style={{width:"100%"}} 
                          id="outlined-basic"  
                          variant="outlined" 
                        />
                        </div>
                 </div>
                 <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Upload Images</span>
                      </div>
                      <div style={{marginTop:10}}>
                        <components.imagePicker setImage={setImage}/>
                        {image && (
                          <div style={{marginTop: 20}}>
                            <Cropper
                              src={image}
                              style={{ height: 400, width: '100%' }}
                              initialAspectRatio={1}
                              preview=".img-preview"
                              guides={false}
                              ref={cropperRef}
                              viewMode={1}
                              responsive={true}
                              autoCropArea={1}
                              checkOrientation={false}
                            />
                            <Button 
                              onClick={deleteimage}
                              variant="outlined"
                              color="error"
                              style={{marginTop: 10}}
                            >
                              Delete Image
                            </Button>
                          </div>
                        )}
                      </div>
                 </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit} autoFocus variant="contained" color="primary">
            SAVE
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
